export const parseInvoices = (invoices) => {
  return invoices.map((i) => ({
    ...i,
    id: i.booking_number,
  }));
};
